import type { Query } from '@tanstack/react-query'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { CalendarIdentity } from '~/domains/calendar/types'

const CALENDAR_QUERY_KEY = 'calendar-identity'
const SYNC_POLL_INTERVAL = 4000

export function useCalendarIdentityQuery() {
  return useQuery({
    queryKey: [CALENDAR_QUERY_KEY],
    queryFn: async (): Promise<CalendarIdentity | null> =>
      await fetchApiWithToken<CalendarIdentity | null>({
        url: '/v1/calendar/identities'
      }),
    refetchInterval: (
      query: Query<CalendarIdentity | null>
    ): number | false => {
      const identity = query.state.data
      return identity?.uuid && identity.syncStatus === 'pending'
        ? SYNC_POLL_INTERVAL
        : false
    }
  })
}

export function useRevokeCalendarIdentityMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      return await fetchApiWithToken({
        url: '/v1/calendar/identities',
        method: 'DELETE'
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CALENDAR_QUERY_KEY] })
    }
  })
}
